import { z } from "zod/v4";
import { zExt } from "./common/zod-util";

export enum TnplContractStatus {
  TRIAL_ACTIVE = "trial_active",
  CANCELLED = "cancelled",
  COMPLETE_PAID_BY_CUSTOMER = "complete_paid_by_customer",
  COMPLETE_RETURNED = "complete_returned",
}

export enum TnplChargeStatus {
  INITIATED_AUTHORIZE_PENDING = "initiated_authorize_pending",
  AUTHORIZED = "authorized",
  CAPTURED_PENDING = "captured_pending",
  SUCCEEDED = "succeeded",
  FAILED = "failed",
}

export enum TnplCancellationType {
  INITIAL_PAYMENT_FAILED = "initial_payment_failed",
  INELIGIBLE_FOR_TRIAL = "ineligible_for_trial",
}

export const TnplChargeSchema = z.object({
  idempotencyKey: z.string(),
  date: z.date(),
  status: z.enum(TnplChargeStatus),
  amount: z.number().optional(),
});

export type TnplCharge = z.infer<typeof TnplChargeSchema>;

export const TnplContractSchema = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  tnplContractTemplate: zExt.objectId(),
  shopifyOrderId: z.number(),
  shopifyLineItemIds: z.array(z.number()),
  shopifySellingPlanId: z.number(),
  shopifyPaymentScheduleIds: z.array(z.number()).optional(),
  shopifyPaymentMandateIds: z.array(z.string()),
  initialSellingPlanAmount: z.number(),
  sellingPlanCurrency: z.string(),
  order: zExt.objectId(),
  return: zExt.objectId().optional(),
  orderDate: z.date(),
  initialPaymentDate: z.date().optional(),
  deliveryDate: z.date().optional(),
  returnedDate: z.date().optional(),
  approvedDate: z.date().optional(),
  trialPeriodEnd: z.date().optional(),
  chargeDate: z.date().optional(),
  status: z.enum(TnplContractStatus),
  charges: z.array(TnplChargeSchema),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type TnplContract = z.infer<typeof TnplContractSchema>;
export interface ITnplContract extends z.ZodType<TnplContract> {}
